<div>
  <!--<app-rec-date-search-header [recordCount]="recDateSearchResults.recordCount"></app-rec-date-search-header> -->
  <app-rec-alpha-search-header [recordCount]="recAlphaSearchResults.recordCount" ></app-rec-alpha-search-header>
</div>
<div>
  <app-rec-alpha-search-grid></app-rec-alpha-search-grid> 
</div>
